import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.split";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';

function ResponsiveImageSet(_ref) {
  var x2 = _ref.x2,
      x3 = _ref.x3,
      cleanProps = _objectWithoutProperties(_ref, ["x2", "x3"]);

  var src = cleanProps.src,
      alt = cleanProps.alt;
  var lastBackslash = src.lastIndexOf('/');
  var qualifier = src.substring(0, lastBackslash);

  var _src$substring$split = src.substring(lastBackslash + 1).split('.'),
      _src$substring$split2 = _slicedToArray(_src$substring$split, 2),
      name = _src$substring$split2[0],
      ext = _src$substring$split2[1];

  var options = Object.assign({}, cleanProps, {
    alt: alt || name.replace(/[-_]/g, ' ') || 'image',
    srcSet: [src].concat(_toConsumableArray(x2 ? ["".concat(qualifier, "/").concat(name, "@2x.").concat(ext, " 2x")] : []), _toConsumableArray(x3 ? ["".concat(qualifier, "/").concat(name, "@3x.").concat(ext, " 3x")] : [])).join(', ')
  });
  return React.createElement(Image, options);
}

ResponsiveImageSet.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  x2: PropTypes.bool,
  x3: PropTypes.bool
};
ResponsiveImageSet.defaultProps = {
  className: '',
  alt: '',
  x2: true,
  x3: true
};
export default React.memo(ResponsiveImageSet);